import { APIConfiguration } from '@savgroup-front-common/configuration';
import { isFileType } from '@savgroup-front-common/core/helpers/AdditionalInformations/isFileType';
import { AdditionalInformationExtended, Reason } from '@/types';

interface ReasonAdapterArgs {
  reasonSelected?: Reason;
  claimIds: string[];
}

export const buildFileUploadEndpoints = ({
  claimIds,
  id,
}: {
  claimIds: string[];
  id: string;
}): Record<string, { uploadEndpoint: string; deleteEndpoint: string }> => {
  return claimIds.reduce((acc, claimId) => {
    return {
      ...acc,
      [claimId]: {
        uploadEndpoint: `${APIConfiguration.claim}claims/${claimId}/additionalInformation/${id}/file`,
        deleteEndpoint: `${APIConfiguration.claim}claims/${claimId}/additionalInformation/${id}/file`,
      },
    };
  }, {});
};

export const reasonAdapter = ({
  reasonSelected,
  claimIds,
}: ReasonAdapterArgs) => {
  const newNeededInformation =
    reasonSelected?.neededInformation?.reduce<AdditionalInformationExtended[]>(
      (acc, curr) => {
        const { id } = curr;

        return [
          ...acc,
          {
            ...curr,
            internalId: id,
            fileUploadEndpoints: isFileType(curr)
              ? buildFileUploadEndpoints({
                  claimIds,
                  id,
                })
              : undefined,
            claimIds,
          },
        ];
      },
      [],
    ) || [];

  return {
    ...reasonSelected,
    neededInformation: newNeededInformation,
  };
};
